var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.Iftoken)?_c('agency-need-auth-details-vue'):_vm._e(),(!_vm.Iftoken)?_c('agency-need-un-auth-details-vue'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }